export default __webpack_public_path__ + "assets/d3c1f208c7c8284bfe4a31c924d3adb9.png";